export default __webpack_public_path__ + "static/media/2.79996ad3.png";